import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { getIsPatagoniaSidebarCollapseAnimationFinished } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { useQueryParams } from 'ContentEditorUI/utils/routingUtils';
import { useFetchBySuggestionIdQuery, useDismissLazyQuery } from '../../__generated__/chirp/com/hubspot/page/content/generator/rpc/CroAgentLandingPageBrandingOptimizationsRpc.hooks';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChangeRecommendedSection = () => {
  const [hasDismissedTooltip, setHasDismissedTooltip] = useState(false);
  const {
    moduleId: moduleIdParam,
    croSuggestionId: suggestionIdParam
  } = useQueryParams();
  const animationFinished = useSelector(getIsPatagoniaSidebarCollapseAnimationFinished);
  const {
    data,
    loading,
    error
  } = useFetchBySuggestionIdQuery({
    variables: {
      suggestionId: Number(suggestionIdParam)
    },
    skip: !suggestionIdParam || hasDismissedTooltip
  });
  const [dismissOptimization] = useDismissLazyQuery();
  const handleDismiss = useCallback(() => {
    setHasDismissedTooltip(true);
    if (data !== null && data !== void 0 && data.optimizationId) {
      dismissOptimization({
        variables: {
          optimizationId: data.optimizationId
        }
      });
    }
  }, [data === null || data === void 0 ? void 0 : data.optimizationId, dismissOptimization]);
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  if (!moduleIdParam || !suggestionIdParam || error || !(data !== null && data !== void 0 && data.suggestion) || hasDismissedTooltip || !animationFinished) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    paddingInline: "600",
    paddingBlockStart: "300",
    alignItems: "center",
    gap: "200",
    children: [/*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "changeRecommended.label"
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      defaultOpen: true,
      use: "longform",
      placement: "right",
      headingText: data.suggestion.summary,
      maxInlineSize: "350px",
      title: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "300",
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "200",
          children: [/*#__PURE__*/_jsx(Text, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "changeRecommended.recommendedChange"
            })
          }), /*#__PURE__*/_jsx(Text, {
            children: data.suggestion.recommendedChange
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "200",
          children: [/*#__PURE__*/_jsx(Text, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "changeRecommended.why"
            })
          }), /*#__PURE__*/_jsx(Text, {
            children: data.suggestion.reasoning
          })]
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary",
          size: "small",
          onClick: handleDismiss,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "changeRecommended.dismissButton"
          })
        })]
      }),
      children: /*#__PURE__*/_jsx(InfoIcon, {
        size: "300"
      })
    })]
  });
};
export default ChangeRecommendedSection;